/**
 * Mobile Navigation Component
 * Handles the collapsible mobile menu with smooth animations
 */
import { AnimatePresence, motion } from 'framer-motion';
import { Menu, X } from 'lucide-react';
import { useState, useCallback } from 'react';
import { NAV_LINKS } from '../../config/brand';
import { navigateToSection } from '../../utils/navigation';

const MobileNavigation = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = useCallback(() => {
    setMenuOpen((prev) => !prev);
  }, []);

  const handleNavClick = useCallback((href) => {
    setMenuOpen(false);
    // Small delay to ensure menu closes before scrolling
    setTimeout(() => {
      navigateToSection(href.slice(1));
    }, 100);
  }, []);

  return (
    <>
      <button
        className="cursor-pointer p-2 pr-6 md:hidden"
        onClick={toggleMenu}
        aria-label={menuOpen ? 'Close menu' : 'Open menu'}
      >
        {menuOpen ? <X size={24} /> : <Menu size={24} />}
      </button>

      <AnimatePresence>
        {menuOpen && (
          <motion.ul
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: 'auto', opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.2 }}
            className="absolute top-full left-0 z-50 w-full space-y-2 bg-zinc-900/95 px-6 pt-4 pb-4 backdrop-blur-md md:hidden"
          >
            {NAV_LINKS.map(({ href, label }) => (
              <li key={href}>
                <button
                  onClick={() => handleNavClick(href)}
                  className="block w-full py-1 text-left hover:text-zinc-300"
                >
                  {label}
                </button>
              </li>
            ))}
          </motion.ul>
        )}
      </AnimatePresence>
    </>
  );
};

export default MobileNavigation;
